import { render, staticRenderFns } from "./userDetailitems.vue?vue&type=template&id=05bccc65&scoped=true&"
import script from "./userDetailitems.vue?vue&type=script&lang=js&"
export * from "./userDetailitems.vue?vue&type=script&lang=js&"
import style0 from "./userDetailitems.vue?vue&type=style&index=0&id=05bccc65&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05bccc65",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VOverlay,VProgressCircular,VRow})
